import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'fence',
      d: 'M3,-4h0.5v2h-0.5zM-3.5,-3.5h0.5v0.5h-0.5zM-0.5,-3.5h0.5v1.5h-0.5zM-4,-3h1v1h-1zM-2,-2.5h0.5v0.5h-0.5zM-4,-2h0.5v2h-0.5zM-1,-2h1v0.5h-1zM0.5,-2h3v0.5h-3zM-3,-1.5h3v0.5h-3zM0.5,-1.5h2v0.5h-2zM3,-1.5h0.5v1h-0.5zM-3,-1h1v0.5h-1zM-0.5,-1h0.5v1h-0.5z',
    },
    {
      paint: [
        ['fence', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M3,-4.5h1v0.5h-1zM-4,-4h0.5v1h-0.5zM-0.5,-4h1v0.5h-1zM0.5,-3.5h2.5v1h-2.5zM-3,-3h2.5v0.5h-2.5zM-3,-2.5h1v0.5h-1z',
    },
    {
      paint: [
        ['fence', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M3.5,-4h0.5v3.5h-0.5zM0,-3.5h0.5v3.5h-0.5zM-1.5,-2.5h1v0.5h-1zM-3.5,-2h2v0.5h-2zM-3.5,-1.5h0.5v1.5h-0.5z',
    },
  ],
  pixels: 87,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'fence',
      d: 'M-4,-4h0.5v0.5h-0.5zM3,-4h0.5v2h-0.5zM-4,-3.5h1v0.5h-1zM-4,-3h0.5v2.5h-0.5zM-0.5,-3h1v0.5h-1zM-2,-2.5h1v0.5h-1zM-0.5,-2.5h0.5v1h-0.5zM2,-2h1.5v0.5h-1.5zM-3,-1.5h3v0.5h-3zM0.5,-1.5h3v0.5h-3zM-1.5,-1h1.5v0.5h-1.5zM0.5,-1h1v0.5h-1zM3,-1h0.5v0.5h-0.5zM-0.5,-0.5h0.5v1h-0.5z',
    },
    {
      paint: [
        ['fence', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-4,-4.5h1v0.5h-1zM3,-4.5h1v0.5h-1zM-3,-3.5h1v0.5h-1zM-0.5,-3.5h1v0.5h-1zM2,-3.5h1v0.5h-1zM-3,-3h2.5v0.5h-2.5zM0.5,-3h2.5v0.5h-2.5zM-1,-2.5h0.5v0.5h-0.5zM0.5,-2.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['fence', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M-3.5,-4h0.5v0.5h-0.5zM3.5,-4h0.5v3.5h-0.5zM-3.5,-3h0.5v1h-0.5zM-2.5,-2.5h0.5v0.5h-0.5zM0,-2.5h0.5v3h-0.5zM-3.5,-2h3v0.5h-3zM-3.5,-1.5h0.5v1h-0.5z',
    },
  ],
  pixels: 90,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'fence',
      d: 'M0.5,-4h1v0.5h-1zM2.5,-4h1v1h-1zM-3.5,-3.5h0.5v0.5h-0.5zM-1.5,-3.5h0.5v2h-0.5zM0.5,-3.5h0.5v3h-0.5zM1.5,-3.5h0.5v0.5h-0.5zM-4,-3h1v0.5h-1zM1.5,-3h1v0.5h-1zM3,-3h0.5v0.5h-0.5zM-4,-2.5h0.5v2.5h-0.5zM1.5,-2.5h0.5v0.5h-0.5zM2.5,-2.5h1v0.5h-1zM2,-2h1.5v0.5h-1.5zM-3,-1.5h2v0.5h-2zM1.5,-1.5h0.5v0.5h-0.5zM3,-1.5h0.5v1h-0.5zM-3,-1h0.5v0.5h-0.5zM-1.5,-1h0.5v1h-0.5z',
    },
    {
      paint: [
        ['fence', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M1,-4.5h0.5v0.5h-0.5zM3,-4.5h1v0.5h-1zM-4,-4h0.5v1h-0.5zM-1.5,-4h1v0.5h-1zM-3,-3h1.5v0.5h-1.5zM-3,-2.5h1v0.5h-1z',
    },
    {
      paint: [
        ['fence', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M3.5,-4h0.5v3.5h-0.5zM-1,-3.5h0.5v3.5h-0.5zM1,-3.5h0.5v1.5h-0.5zM2,-3.5h0.5v0.5h-0.5zM2.5,-3h0.5v0.5h-0.5zM-3.5,-2.5h0.5v2.5h-0.5zM2,-2.5h0.5v0.5h-0.5zM1,-2h1v0.5h-1zM1,-1.5h0.5v1h-0.5z',
    },
  ],
  pixels: 85,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
